<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14MzoHR/tc-custom/9780253027153.jpg?1721429486390" alt="This image is the cover for the book Oceans of Kansas, Life of the Past"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oceans of Kansas, Life of the Past
      </h1>
      <p class="bookDescription body article font2">
        <b>“Excellent . . . Those who are interested in vertebrate paleontology or in the scientific history of the American midwest should really get a copy.” —<i>PalArch’s Journal of Vertebrate Paleontology</i></b><br/><br/>Revised, updated, and expanded with the latest interpretations and fossil discoveries, the second edition of <i>Oceans of Kansas</i> adds new twists to the fascinating story of the vast inland sea that engulfed central North America during the Age of Dinosaurs. Giant sharks, marine reptiles called mosasaurs, pteranodons, and birds with teeth all flourished in and around these shallow waters. Their abundant and well-preserved remains were sources of great excitement in the scientific community when first discovered in the 1860s and continue to yield exciting discoveries 150 years later. Michael J. Everhart vividly captures the history of these startling finds over the decades and re-creates in unforgettable detail these animals from our distant past and the world in which they lived—above, within, and on the shores of America’s ancient inland sea.<br/><br/><b>“<i>Oceans of Kansas</i> remains the best and only book of its type currently available. Everhart’s treatment of extinct marine reptiles synthesizes source materials far more readably than any other recent, nontechnical book-length study of the subject.” —<i>Copeia</i></b><br/><br/><b>“[The book] will be most useful to fossil collectors working in the local region and to historians of vertebrate paleontology . . . Recommended.” —<i>Choice</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael J. Everhart
      </h2>
      
      <p class="authorDescription body article"><P>Michael J. Everhart, Adjunct Curator of Paleontology at the Sternberg Museum of Natural History in Hays, Kansas, is an expert on the Late Cretaceous of western Kansas. He is the creator of the award-winning "Oceans of Kansas" paleontology website at www.oceansofkansas.com. He lives in Derby, Kansas.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?385c8ef7